import { useState } from 'react';
import type { JobRecord } from './core/types';
import type { PipelineOutput } from './core/pipeline';
import UploadPage from './components/UploadPage';
import ProcessingPage from './components/ProcessingPage';
import ResultsPage from './components/ResultsPage';
import ChangelogModal from './components/ChangelogModal';

export type Screen = 'upload' | 'processing' | 'results';

export interface RunState {
  sourceBytes: ArrayBuffer;
  sourceFile: File;
  /** null when processing locally without uploading. */
  job: JobRecord | null;
  pipeline?: PipelineOutput;
}

export default function App() {
  const [screen, setScreen] = useState<Screen>('upload');
  const [run, setRun] = useState<RunState | null>(null);
  const [logOpen, setLogOpen] = useState(false);

  const startRun = (state: RunState) => {
    setRun(state);
    setScreen('processing');
  };

  const finishRun = (job: JobRecord | null, pipeline: PipelineOutput) => {
    setRun((prev) => (prev ? { ...prev, job, pipeline } : prev));
    setScreen('results');
  };

  const reset = () => {
    setRun(null);
    setScreen('upload');
  };

  return (
    <>
      {screen === 'processing' && run ? (
        <ProcessingPage
          key={run.job?.jobId ?? 'local'}
          run={run}
          onFinished={(job, pipeline) => finishRun(job, pipeline)}
          onError={(message) => {
            alert(`处理失败：${message}`);
            reset();
          }}
          onCancel={reset}
        />
      ) : screen === 'results' && run?.pipeline ? (
        <ResultsPage run={run} onBack={reset} />
      ) : (
        <UploadPage onStarted={startRun} />
      )}
      <button className="version-log-btn" onClick={() => setLogOpen(true)}>
        版本日志
      </button>
      <ChangelogModal open={logOpen} onClose={() => setLogOpen(false)} />
    </>
  );
}
